import styled, { css } from "styled-components";

interface ButtonStyleProps {
  $size: "xsm" | "sm" | "md" | "lg" | "full" | "icon";
  $width?: string;
  $color: "primary100" | "white100" | "gray100";
  $layout: "solid" | "outline" | "text" | "icon";
  $isFocused?: boolean;
  $boxShadow?: string;
  $marginTop?: string;
}

export const Buttons = styled.button<ButtonStyleProps>`
  touch-action: manipulation;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);

  display: flex;
  width: ${(props) => (props.$width ? props.$width : "auto")};
  font-family: "Pretendard";
  white-space: nowrap;
  border-radius: 10px;
  align-items: center;
  justify-content: center;
  box-shadow: ${(props) => props.$boxShadow};
  transition: all 0.2s ease;
  margin-top: ${(props) => (props.$marginTop ? props.$marginTop : "")};
  // 사이즈별
  ${(props) =>
    props.$size === "xsm" &&
    css`
      height: 34px;
      padding: ${props.$width ? "0px" : "0 14px"};
      font-size: 1.3rem;
    `}

  ${(props) =>
    props.$size === "sm" &&
    css`
      height: 40px;
      padding: ${props.$width ? "0px" : "0 14px"};
      font-size: 1.4rem;
    `}

  ${(props) =>
    props.$size === "md" &&
    css`
      height: 48px;
      padding: ${props.$width ? "0px" : "0 20px"};
      font-size: 1.6rem;
    `}

  ${(props) =>
    props.$size === "lg" &&
    css`
      height: 52px;
      padding: ${props.$width ? "0px" : "0 26px"};
      font-size: 1.8rem;
    `}
  
  ${(props) =>
    props.$size === "full" &&
    css`
      height: 60px;
      width: ${props.$width ? props.$width : "100%"};
      padding: ${props.$width ? "0px" : "0 50px"};
      font-size: 2rem;
      font-weight: 500;
    `}

  // 레이아웃별
  ${(props) =>
    props.$layout === "solid" &&
    css`
      color: ${props.$isFocused
        ? props.theme.colors.white100
        : props.$color === "white100"
        ? props.theme.colors.primary100
        : props.$color === "gray100"
        ? props.theme.colors.black30
        : props.theme.colors.white100};
      border: none;
      background: ${props.$isFocused
        ? props.theme.colors.primary100
        : props.$color === "gray100"
        ? props.theme.colors.black10
        : props.theme.colors[props.$color]};

      &:active {
        background: ${props.$isFocused
          ? props.theme.colors.primary100
          : props.theme.colors[props.$color + "Hover"]};
      }
    `}

  ${(props) =>
    props.$layout === "outline" &&
    css`
      color: ${props.theme.colors[props.$color]};
      border: 1px solid ${props.theme.colors[props.$color]};
      background: ${props.$color === "white100"
        ? "none"
        : props.theme.colors.white100};

      &:active {
        background: ${props.theme.colors.black10};
      }
    `}

  ${(props) =>
    props.$layout === "text" &&
    css`
      color: ${props.theme.colors[props.$color]};
      border: none;
      background: none;

      &:active {
        background: ${props.theme.colors.black10};
      }
    `}

      ${(props) =>
    props.$layout === "icon" &&
    css`
      display: flex;
      color: ${props.theme.colors[props.$color]};
      border: none;
      background: none;
      align-items: center;
      justify-content: center;

      &:active {
        background: ${props.theme.colors.black10};
      }
    `}
`;
